import styled from "styled-components"

import { maxWidth } from "utils"

import GenericModal from "components/modal"

export const Modal = styled(GenericModal)`
  border-radius: 1.5rem;
  background-color: ${({ theme }) => theme.colors.background.page};

  ${maxWidth.mobile`
    max-width: 100%;
    margin-top: 0rem;
    overflow-y: auto;
  `}

  ${maxWidth.tablet`
    max-width: 80%;
  `}

  ${maxWidth.desktopL`
    max-width: 90%;
    margin: 0.5rem;
  `}
`

export const Content = styled.div`
  padding: 3rem;
  color: ${({ theme }) => theme.colors.text.primary};

  ${maxWidth.desktopL`
    padding: 3rem 1rem;
  `}
`

export const TopRow = styled.div`
  text-align: right;

  ${maxWidth.desktopL`
    padding-right: 2rem;
  `}
`

export const ClickableLink = styled.a`
  text-decoration: underline;
  color: #a35ca2;
`

export const BottomActions = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`

export const Button = styled.button`
  display: block;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.54;
  text-decoration: underline;
  color: #767676;
`

export const LinkButton = styled.button`
  margin: 0 0.5rem;
  font-size: 1.6rem;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.text.primary};
`
